/*
 * Copyright 2026 Sony Corporation
 */

import { Box, Button, Typography } from '@mui/material';

export interface ConfirmBarProps {
  /** How many ops are waiting, which is the reason this bar is here at all. */
  ops: number;
  onApply: () => void;
  onDiscard: () => void;
}

/**
 * Apply / Discard for a batch too large to find out about afterwards
 * (devplan §7.4 rule 5).
 *
 * Discard is the quiet one: nothing has happened yet, so the risk is in
 * applying, and the destructive-looking button would be the wrong one to warn
 * about.
 */
export const ConfirmBar = ({ ops, onApply, onDiscard }: ConfirmBarProps) => (
  <Box className="mt-1 flex items-center gap-1">
    <Typography variant="caption" color="text.secondary" className="flex-1">
      {ops} changes — not applied yet
    </Typography>
    <Button size="small" onClick={onDiscard}>
      Discard
    </Button>
    <Button size="small" variant="contained" onClick={onApply}>
      Apply
    </Button>
  </Box>
);
